export default class Flag {
  constructor (value, options) {
    Object.assign(this, { value }, options)
  }

  extract (raw) {
    if (raw.constructor !== String) {
      return [false, raw]
    }
    return this._test(raw)
  }

  execute (text, { onTrue, onFalse }) {
    const params = this.extract(text)
    const match = params.shift()
    return match ? onTrue(...params) : onFalse(text)
  }

  _test () {
    throw new Error('unimplemented')
  }
}

Flag.Prefix = class PrefixFlag extends Flag {
  _test (raw) {
    const match = raw.startsWith(`${this.value} `)
    return [match, raw.replace(new RegExp(`^${this.value} `), '')]
  }
}

Flag.Suffix = class SuffixFlag extends Flag {
  _test (raw) {
    const match = raw.endsWith(` ${this.value}`)
    return [match, raw.replace(new RegExp(` ${this.value}$`), '')]
  }
}

Flag.Parameter = class ParameterFlag extends Flag {
  _test (raw) {
    const seperator = ` ${this.value} `
    return raw.includes(seperator) ? raw.split(seperator).reverse() : [undefined, raw]
  }
}
